<template>
    <div class="container">
        <div class="row">
            <div class="col-sm">
                <div class="card-body">
                    <h1>Hvala !</h1>
                    <h3>Vaša porudžbina je zabeležena i možete je očekivati u roku od 2 do 3 dana</h3>
                    <div class="button-row">
                        <button class='btn btn-outline-secondary' @click="$router.push('/shop')">Prodavnica</button>
                    </div>
                    <h3>Potvrda o porudžbini poslata je na email</h3>
                    <h3 style="color: #967bb6">{{email}}</h3>
                    <small>*Za sve dodatne informacije možete nam se obratiti putem instagrama: @olivia.prirodni.sapuni</small>
                </div>
            </div>
        </div>
        <div class="row row-custom" style="margin-top: 5%">
            <div class="col-custom">
                <h4>Vaši podaci</h4>
                <p>Ime: {{firstName}}</p>
                <p>Prezime: {{lastName}}</p>
                <p>Grad: {{city}}</p>
                <p>Adresa: {{address}}</p>
                <p>Apartman: {{apartment}}</p>
                <p>Email: {{email}}</p>
                <p>Telefon: {{phone}}</p>
            </div>
            <div class="col-custom">
                <h4>Porudžbina</h4>
                <p>Proizvodi: {{items}}</p>
                <p v-if="smells">Mirisi:<br>{{smells}}</p>
                <p>Cena: {{price}}</p>
                <p>Cena poštarine: {{shippingPrice}}</p>
                <p>Napomena: {{note}}</p>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
    name: 'CheckoutReceipt',
    data() {
        return {
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            city: '',
            address: '',
            apartment: '',
            items: '',
            price: '',
            shippingPrice: '',
            note: '',
            smells: ''
        }
    },
    computed: {
        ...mapGetters([
            'getCurrentCustomer',
            'getCurrentOrder',
            'getTotalPriceWithShipping',
            'getTotalPrice',
            'getShippingCost'
        ])
    },
    methods: {
    },
    mounted() {
        const customer = this.getCurrentCustomer
        this.firstName = customer.firstName
        this.lastName = customer.lastName
        this.email = customer.email
        this.phone = customer.phoneNumber
        this.city = customer.city
        this.address = customer.address
        this.apartment = customer.apartment

        const order = this.getCurrentOrder
        const counts = {}

        for (const item of order.items)
            counts[item.name] = counts[item.name] ? counts[item.name] + 1 : 1;
        for (const item in counts)
            this.items += `${counts[item]}x ${item} | `

        this.items = this.items.substring(0, this.items.length - 3)
        this.price = order.totalPrice + ' RSD'
        this.shippingPrice = this.getShippingCost + ' RSD'
        this.note = order.note ? order.note : '/'
        this.smells = order.smells ? order.smells : ''
    },
    beforeDestroy() {
        this.$store.commit('setCurrentCustomer', {})
        this.$store.commit('clearCart')
    }
}
</script>

<style scoped>
	* {
		background: #F0EAD6 !important;
	}

    .row-custom {
        flex-wrap: wrap;
        justify-content: space-around;
    }

    .col-custom {
        flex-basis: auto;
    }

    @media screen and (max-width: 600px) {
        .col-custom {
            flex-grow: 1;
            padding: 20px;
        }

        h1 {
            font-size: 30px !important;
        }

        h3 {
            font-size: 18px !important;
        }

        button {
            font-size: 15px !important;
            width: 200px !important;
            padding: 10px !important;
        }
    }

    .card-body {
        margin-top: 10%;
    }

    small {
        display: flex;
        justify-content: center;
    }

    h1 {
        font-size: 60px;
        display: flex;
        justify-content: center;
    }

    h3 {
        font-size: 26px;
        font-weight: normal;
        display: flex;
        justify-content: center;
    }

    .button-row {
        margin: 30px;
        display: flex;
        justify-content: center;
    }

    .checkout-button {
        background: transparent;
        color: #967bb6;
        text-transform: uppercase;
        font-size: 14px;
        font-weight: bold;
        width: 150px;
        padding: 10px;
        border: 1px solid #967bb6;
        border-radius: 0;
        cursor: pointer;
    }

    .checkout-button:hover,
    .checkout-button:active,
    .checkout-button:focus {
        background: transparent;
        border: 1px solid #6f5193 ;
        color: #6f5193 ;
    }

    button {
        background: transparent;
        color: #967bb6;
        text-transform: uppercase;
        font-size: 20px;
        font-weight: bold;
        width: 300px;
        padding: 15px;
        border: 1px solid #967bb6;
        border-radius: 0;
        cursor: pointer;
    }

    button:hover,
    button:active,
    button:focus {
        background: transparent;
        border: 1px solid #6f5193 ;
        color: #6f5193 ;
    }

    /* Smells section styling */
    p {
        margin-bottom: 8px;
        line-height: 1.4;
    }

    /* Format smells text to preserve line breaks */
    p:has(+ p) {
        white-space: pre-line;
    }
</style>
